// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCommentRequest
 */
export interface CreateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCommentRequest
     */
    comment_text: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentRequest
     */
    section_reference: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommentRequest
     */
    vendor_company: string;
    /**
     * DTA version this comment belongs to
     * @type {string}
     * @memberof CreateCommentRequest
     */
    version: string;
}

/**
 * Check if a given object implements the CreateCommentRequest interface.
 */
export function instanceOfCreateCommentRequest(value: object): value is CreateCommentRequest {
    if (!('comment_text' in value) || value['comment_text'] === undefined) return false;
    if (!('section_reference' in value) || value['section_reference'] === undefined) return false;
    if (!('vendor_company' in value) || value['vendor_company'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function CreateCommentRequestFromJSON(json: any): CreateCommentRequest {
    return CreateCommentRequestFromJSONTyped(json, false);
}

export function CreateCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment_text': json['comment_text'],
        'section_reference': json['section_reference'],
        'vendor_company': json['vendor_company'],
        'version': json['version'],
    };
}

export function CreateCommentRequestToJSON(json: any): CreateCommentRequest {
    return CreateCommentRequestToJSONTyped(json, false);
}

export function CreateCommentRequestToJSONTyped(value?: CreateCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment_text': value['comment_text'],
        'section_reference': value['section_reference'],
        'vendor_company': value['vendor_company'],
        'version': value['version'],
    };
}
